import React, { useState } from "react";
import {
	Link,
    useLocation
} from "react-router-dom";
import CampanhaService from "../services/CampanhaService";

function HomeIcon(props) {

	const campanhaService = new CampanhaService();
	let campanhaCorrente = campanhaService.campanhaCorrente();
	let beginDate
	let now = new Date().getTime();
	let location = useLocation();
	let tipoInscricao
	let legalTerm
	let requiredInterests
	if(campanhaCorrente){
		let dtStart = campanhaCorrente.startDate.split(" ");
		let dateStart = dtStart[0].split("/");
		let hourStart = dtStart[1].split(":");
		beginDate = new Date(dateStart[2], dateStart[1]-1, dateStart[0], hourStart[0], hourStart[1], hourStart[2]);
		tipoInscricao = campanhaCorrente.tipoInscricao
		legalTerm = campanhaCorrente.legalTerm
		requiredInterests = campanhaCorrente.requiredInterests

	}
	return (
	<>
		{ 
			tipoInscricao === "ELEGIBILIDADE" && legalTerm && !props.usuarioLogado.legalTerm
            || requiredInterests === true && location.pathname === '/interests' && beginDate <= now ? null : (
				<Link to="/">
					<img src="/menu.png" className="menu" alt="Home" />
				</Link>
		)}
							
	</>	
	);
}

export default HomeIcon;
